import React, { useState, useEffect } from 'react';
import Markdown from 'react-markdown';
import { observer, inject } from 'mobx-react';

import type RootStore from '../../stores/RootStore';
import styles from './PrivacyPolicy.module.scss';

interface PrivacyPolicyProps {
  rootStore?: RootStore;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = observer(
  ({ rootStore }) => {
    const [terms, setTerms] = useState('');

    useEffect(() => {
      void fetch('/privacy-policy.md')
        .then(async (res) => await res.text())
        .then((text) => {
          setTerms(text);
        });
    }, []);

    return (
      <div className={styles.containerWrapper}>
        <div className={styles.container}>
          <h2 className={styles.title}>Privacy Policy </h2>
          <Markdown>{terms}</Markdown>
        </div>
      </div>
    );
  },
);

export default inject('rootStore')(PrivacyPolicy);
